import React, { useMemo } from "react";
import DocumentCard from "@components/DocumentCard/DocumentCard";
import type { ReviewFalProps } from "@features/vessel-call/vessel-call-status/VesselCallDetails/ImoFalReview/types";
import { useDownloadCertificate } from "@pages/vessel-management/vessel-status/hooks/useDownloadCertificate";
import { useTranslation } from "react-i18next";
import { getFal4CrewsEffectsDeclarationData } from "../utils";

const ReviewFal4: React.FC<ReviewFalProps> = ({ vesselCallDetails, vesselRegisterDetails }) => {
  const { t } = useTranslation();
  const { handleDownload, handlePreview } = useDownloadCertificate();
  const { crewsEffectsUrl, fileName, translationTitle, testIds } = useMemo(
    () =>
      getFal4CrewsEffectsDeclarationData({
        vesselCallDetails,
        vesselRegisterDetails,
        t,
      }),
    [vesselCallDetails, vesselRegisterDetails, t],
  );

  return (
    <div className="flex flex-col gap-4" data-testid={testIds.wrapper}>
      <h2 className="text-xl">{translationTitle}</h2>
      {crewsEffectsUrl ? (
        <div className="grid grid-cols-2">
          <DocumentCard
            testId={testIds.card}
            title={""}
            fileName={fileName}
            onDownload={() =>
              handleDownload("certificate", "bff-vessel-call", crewsEffectsUrl, fileName)
            }
            onPreview={() => handlePreview("certificate", "bff-vessel-call", crewsEffectsUrl)}
          />
        </div>
      ) : (
        <div className="text-gray-500 font-normal text-sm" data-testid={testIds.empty}>
          {t("vessel-call.certificates.empty")}
        </div>
      )}
    </div>
  );
};

export default ReviewFal4;
